// biome-ignore-all lint/suspicious/noArrayIndexKey: 位置で決まる固定行で、並び替えも削除もないため index が identity
import { Box, type BoxProps, Grid, type Theme, Typography } from '@mui/material'
import type { ReactElement, ReactNode } from 'react'

export type SimpleGridRow = {
  head?: ReactNode
  body?: ReactNode
  alignItems?: 'center' | 'top'
  height?: number
}

type SimpleGridProps = {
  rows: SimpleGridRow[]
  noDataText?: string
  headSize?: number
  bodySize?: number
  itemMarginBottom?: number
  height?: number
  /** 行ごとの指定が無いときの既定。MUI v9 で BoxProps から system props が消えたので自前で持つ */
  alignItems?: SimpleGridRow['alignItems']
} & BoxProps

export function SimpleGrid({ rows, noDataText, headSize = 4, bodySize = 8, itemMarginBottom = 3, height, alignItems, ...rest }: SimpleGridProps): ReactElement {
  return (
    <Box {...rest}>
      {rows.map((row, i) => (
        <Grid
          container
          key={i}
          sx={{
            mb: i === rows.length - 1 ? 0 : itemMarginBottom,
            alignItems: row.alignItems ?? alignItems ?? 'center',
            minHeight: getHeight(row.height, height),
          }}
        >
          <Grid size={headSize}>{row.head}</Grid>
          <Grid size={bodySize}>{row.body}</Grid>
        </Grid>
      ))}
      {rows.length === 0 && noDataText && (
        <Typography
          variant="body1"
          sx={{
            color: 'text.disabled',
          }}
        >
          {noDataText}
        </Typography>
      )}
    </Box>
  )
}

const getHeight = (rowHeight?: number, height?: number) => {
  return (theme: Theme) => {
    if (rowHeight) {
      return theme.spacing(rowHeight)
    }
    if (height) {
      return theme.spacing(height)
    }
    return undefined
  }
}
